import { render, staticRenderFns } from "./bannerhome.vue?vue&type=template&id=2e5a6be6&"
import script from "./bannerhome.vue?vue&type=script&lang=js&"
export * from "./bannerhome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports